import baseAPI from "../app/baseAPI";

export const ProductReducer = baseAPI.injectEndpoints({
  endpoints(builder) {
    return {
      fetchProductDetails: builder.query({
        query() {
          return {
            url: `/products`,
            method: "GET",
            token: true,
            prefixUrlType : "Catalog"
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      })
    };
  },
});
export const {
  useFetchProductDetailsQuery
} = ProductReducer;
